import { BrandKey } from '../brand/brand.interface';

const brandByHost: Record<string, BrandKey> = {
  localhost: 'telepagos',
  '127.0.0.1': 'telepagos',
  'telepagos.com.ar': 'telepagos',
  'www.telepagos.com.ar': 'telepagos',
  'plataforma.homo.mutualpymerural.com.ar': 'pyme_rural',
  'www.plataforma.homo.mutualpymerural.com.ar': 'pyme_rural',
  'www.plataforma.homo.prestapp.ar':'prestapp',
  'plataforma.homo.prestapp.ar':'prestapp'
  // 'app.alucerto.com.ar': 'alucerto',
  // 'marca-blanca.example.com': 'marca_blanca_generico',
};

export const environment = {
  production: true,
  nombre: 'Homologación',
  url: 'https://backend.homo.telepagos.com.ar/api/',
  urlDescarga: 'https://backend.homo.telepagos.com.ar/',
  brandByHost,
};
